if (!customElements.get('bluen-active-offers')) {
  customElements.define('bluen-active-offers', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-copy-offer]').forEach((button) => {
        button.hidden = false;
      });
      this.onClick ||= this.copyOffer.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    async copyOffer(event) {
      const button = event.target.closest('[data-copy-offer]');
      if (!button || !this.contains(button) || button.disabled) return;
      const card = button.closest('.bluen-active-offers__card');
      const codeElement = card.querySelector('[data-offer-code]');
      const code = codeElement.textContent.trim();
      if (!code) return;
      const label = button.querySelector('[data-copy-label]');
      const status = card.querySelector('[role="status"]');
      const originalLabel = label.textContent;
      button.disabled = true;
      status.textContent = '';

      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(code);
        label.textContent = button.dataset.copiedLabel;
        status.textContent = `${code}: ${button.dataset.copiedLabel}`;
      } catch (error) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(codeElement);
        selection.removeAllRanges();
        selection.addRange(range);
        status.textContent = button.dataset.errorLabel;
      } finally {
        window.setTimeout(() => {
          label.textContent = originalLabel;
          button.disabled = false;
        }, 2000);
      }
    }
  });
}
